import React, { useMemo } from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { contactFieldLocoKeys } from 'src/shared/constants/contact-field-loco-keys'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { FormBaseSubEntity } from './form-base-sub-entity'

interface FormFieldSubEntityProps {
  formEntity: FormInterface
  fieldSubEntity: FormFieldInterface
}

export const FormFieldSubEntity = ({
  formEntity,
  fieldSubEntity,
}: FormFieldSubEntityProps) => {
  const entity = useMemo(
    () => ({
      ...fieldSubEntity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubEntity, formEntity.fieldsCommonStyles],
  )

  return (
    <FormBaseSubEntity
      title={contactFieldLocoKeys[fieldSubEntity.slug]}
      formEntity={formEntity}
      subEntity={fieldSubEntity}
    >
      <BaseEditorField entity={entity} />
    </FormBaseSubEntity>
  )
}
